import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { IToastObject } from "./toast.model";
import { GlobalMessageEnum } from "@ehrCore/interceptors/models/global-message.model";

@Injectable({
  providedIn: "root"
})
export class ToastService {

  private readonly toastSubject: Subject<IToastObject> = new Subject<IToastObject>();

  constructor() { }

  publishToast(toast: IToastObject): void {
    const defaultToast: IToastObject = {
      content: "",
      timeOut: 5000,
      position: { X: "Right", Y: "Bottom" },
      showCloseButton: true,
      type: GlobalMessageEnum.Success,
      cssClass: `ehr-toast ehr-toast-${toast.type || GlobalMessageEnum.Success}`,
    };
    this.toastSubject.next({ ...defaultToast, ...toast, title: null });
  }

  getToast$(): Observable<IToastObject> {
    return this.toastSubject.asObservable();
  }
}
